export function categorySelector(state = 'everything', action) {
  switch (action.type) {
    case 'CATEGORY_SELECTED':
      return action.category;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/category_selected.js